import { env } from '@zopauk/nextjs-env';
import type { ArticleQuery } from '@/utils/dato/generated';
import type { Document } from 'datocms-structured-text-utils';
import { render } from 'datocms-structured-text-to-plain-text';

type Article = NonNullable<ArticleQuery['article']>;

const PUBLISHER = {
  logo: {
    url: 'https://www.datocms-assets.com/23873/1770736571-favicon.svg',
    '@type': 'ImageObject',
  },
  url: 'https://www.zopa.com',
  '@type': 'Organization',
  name: 'Zopa',
};

const DEFAULT_IMAGE = `https://www.datocms-assets.com/23873/1713186272-frame-48.png?auto=format&fit=crop&w=620`;

export function buildBlogPostingSchema(article: Article) {
  const baseUrl = env('NEXT_PUBLIC_WEB_GALLERIA_URL');
  const datePublished = article.date ? `${article.date}T00:00:00Z` : article.createdAt;
  const dateModified = article.updatedAt || datePublished;

  const imageUrl = article.featuredImage?.url ?? DEFAULT_IMAGE;

  const plainText = article.body ? render(article.body as { value: Document }) : null;
  const wordCount = plainText ? plainText.trim().split(/\s+/).filter(Boolean).length : null;

  const schema: Record<string, unknown> = {
    author: {
      url: `${baseUrl}/blog/author/${article.author.slug}`,
      name: article.author.name,
      '@type': 'Person',
    },
    url: `${baseUrl}/blog/article/${article.slug}`,
    '@context': 'https://schema.org',
    description: article.excerpt,
    headline: article.title,
    '@type': 'BlogPosting',
    publisher: PUBLISHER,
    image: imageUrl,
    datePublished,
    dateModified,
  };

  if (wordCount !== null) {
    schema.wordCount = wordCount;
  }

  return schema;
}
